import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { UserModuleSuggestionOutput } from 'infrastructure/graphql/content/user/model/user-module-suggestion.output';
import { UserModuleSuggestion } from 'user/suggestion/user-module-suggestion';

@Injectable({ providedIn: 'root' })
export class UserModuleSuggestionConverterService {
	public userModuleSuggestionAsEntity(
		output: UserModuleSuggestionOutput
	): UserModuleSuggestion {
		if (!output) {
			return null;
		}

		return new UserModuleSuggestion(
			output.user.id,
			output.priority,
			output.organizationModule.id
		);
	}

	public userModuleSuggestionsAsEntities(
		outputs: UserModuleSuggestionOutput[]
	): UserModuleSuggestion[] {
		return reject(outputs, isNil).map((output) =>
			this.userModuleSuggestionAsEntity(output)
		);
	}
}
